import React from "react";
import { showLoading } from "../../../common/Common";
import RestClient from "../../../common/RestClient";
import { BaseListing } from "../../common/BaseListing";
import { DateHelper } from "../../../common/Helpers";
import {
  EVoucherStatus,
  GenericMessages,
  SearchEvoucherBy,
} from "../../../common/Constants";
import {
  NavigationItem,
  NavigationSettings,
} from "../../common/NavigationSettings";
import {
  AuthenticationManager,
  ResourceID,
} from "../../../common/AuthenticationManager";
import { RowFormField } from "../../layout/FormLayout";
import { ExtendValidityDialog } from "./dialogs/ExtendValidityDialog";
import { BaseConfirmReasonDialog } from "../common/BaseConfirmReasonDialog";
import { EVoucherService } from "../../../services/EVoucherService";
import { EVoucherExtensionRequestRestService } from "../../../services/EVoucherExtensionRequestRestService";
import { toast } from "react-toastify";
import { EVoucherActionsHistoryModal } from "./dialogs/EVoucherActionsHistoryModal";
import _ from "lodash";
import { EVoucherExporter } from "../common/EVoucherExporter";
import { FileDownloadModal } from "../batches/dialogs/FileDownloadModal";
import { EVoucherActionDropdown } from "../common/EVoucherActionDropdown";

export class EvoucherListing extends BaseListing {
  constructor() {
    super();
    this.state = {
      searchBy: SearchEvoucherBy.Code,
      evoucherPrograms: [],
      evoucherStatuses: [],
      evoucherStatus: this.getQueryParamValue("evoucherStatus", ""),
      evoucherProgramId: 0,
      eVoucherOrderReference: "",
      eVoucherBatchReference: "",
      code: "",
      selectedEVouchers: [],
      isShowBlockDialog: false,
      isShowUnblockDialog: false,
      isShowBlockAllDialog: false,
      isShowUnblockAllDialog: false,
      isShowExtendValidityDialog: false,
      isShowExtendValidityAllDialog: false,
      isSelectAll: false,
      isShowHistoryDialog: false,
      isShowExportFileDialog: false,
      isShowDownloadAllDialog: false,
    };
    this.eVoucherService = new EVoucherService();
    this.eVoucherExtensionRequestRestService =
      new EVoucherExtensionRequestRestService();
  }

  componentDidMount() {
    this.loadData(0);
    this.loadEvoucherStatuses();
    this.loadEvoucherPrograms();
  }

  componentDidUpdate(prevProps, prevState) {
    const { data, selectedEVouchers } = this.state;
    if (
      data &&
      (!_.isEqual(prevState.data, data) ||
        !_.isEqual(prevState.selectedEVouchers, selectedEVouchers))
    ) {
      const isSelectAll = data.every((dataItem) =>
        selectedEVouchers.some(
          (selectedItem) => selectedItem.id === dataItem.id
        )
      );
      this.setState({
        isSelectAll: isSelectAll,
      });
    }
  }

  getNavigationSettings = () => {
    return new NavigationSettings({
      parentModule: new NavigationItem({
        identifier: "evouchers",
        name: "eVouchers",
        standardized: false,
      }),
      activeModule: new NavigationItem({
        identifier: "evouchers",
        name: "eVoucher",
        standardized: false,
      }),
    });
  };

  loadEvoucherStatuses = () => {
    RestClient.sendGetRequest(
      this.getApiPath() + "/statuses",
      (response) => {
        this.setState({ evoucherStatuses: response });
      },
      (err) => {
        console.log(err);
      }
    );
  };

  loadEvoucherPrograms = () => {
    RestClient.sendGetRequest(
      "/api/v1/evoucher_programs",
      (response) => {
        this.setState({ evoucherPrograms: response.data });
      },
      (err) => {
        console.log(err);
      }
    );
  };

  getApiPath = () => "/api/v1/evouchers";

  getDefaultSort = () => "-UpdatedOn";

  onProgramChange = (e) => {
    this.setState({ evoucherProgramId: parseInt(e.target.value) });
  };

  onStatusChange = (e) => {
    this.setState({ evoucherStatus: parseInt(e.target.value) });
  };

  onSearchByChange = (e) => {
    if (this.state.searchBy !== e.target.value) {
      this.setState({
        searchBy: e.target.value,
        eVoucherOrderReference: "",
        eVoucherBatchReference: "",
        code: "",
      });
    }
  };

  injectSearchTerm(queryParameters, searchBy) {
    const {
      code,
      evoucherStatus,
      evoucherProgramId,
      eVoucherBatchReference,
      eVoucherOrderReference,
    } = this.state;

    return super.injectSearchTerm(queryParameters, {
      eVoucherBatchReference,
      eVoucherOrderReference,
      code,
      evoucherProgramId: evoucherProgramId ? [evoucherProgramId] : [],
      status: evoucherStatus,
    });
  }

  onInputChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  onSelectEVoucher = (e, item) => {
    const isChecked = e.target.checked;
    const { selectedEVouchers } = this.state;

    this.setState({
      selectedEVouchers: isChecked
        ? [...selectedEVouchers, item]
        : selectedEVouchers.filter(
            (selectedItem) => selectedItem.id !== item.id
          ),
    });
    if (!isChecked) {
      this.setState({ isSelectAll: false });
    }
  };

  onSelectAll = (e) => {
    const { data, selectedEVouchers } = this.state;
    const isChecked = e.target.checked;

    const updatedSelectedEVouchers = isChecked
      ? selectedEVouchers.concat(
          data.filter(
            (item) =>
              !selectedEVouchers.some((selected) => selected.id === item.id)
          )
        )
      : [];

    this.setState({
      selectedEVouchers: updatedSelectedEVouchers,
    });
  };

  toggleExtendValidityDialog = (visible) => {
    this.setState({ isShowExtendValidityDialog: visible });
  };

  toggleExtendValidityAllDialog = (visible) => {
    this.setState({ isShowExtendValidityAllDialog: visible });
  };

  toggleConfirmBlockDialog = (visible) => {
    this.setState({ isShowBlockDialog: visible });
  };

  toggleConfirmUnblockDialog = (visible) => {
    this.setState({ isShowUnblockDialog: visible });
  };

  toggleConfirmBlockAllDialog = (visible) => {
    this.setState({ isShowBlockAllDialog: visible });
  };
  toggleConfirmUnblockAllDialog = (visible) => {
    this.setState({ isShowUnblockAllDialog: visible });
  };

  toggleExportFileDialog = (visible) => {
    this.setState({
      isShowExportFileDialog: visible,
    });
  };

  toggleDownloadAllDialog = (visible) => {
    this.setState({
      isShowDownloadAllDialog: visible,
    });
  };

  toggleHistoryDialog = (visible) => {
    this.setState({ isShowHistoryDialog: visible });
  };

  openBlockDialog = () => {
    const { selectedEVouchers } = this.state;
    const invalidEvouchers = selectedEVouchers.filter(
      (x) => x.status !== EVoucherStatus.Active
    );

    if (invalidEvouchers.length > 0) {
      toast.dismiss();
      toast.error(
        `${invalidEvouchers.map((x) => x.code).join(", ")} cannot be blocked" `
      );
      return;
    }

    this.toggleConfirmBlockDialog(true);
  };

  openUnblockDialog = () => {
    const { selectedEVouchers } = this.state;
    const invalidEvouchers = selectedEVouchers.filter(
      (x) => x.status !== EVoucherStatus.Blocked
    );

    if (invalidEvouchers.length > 0) {
      toast.dismiss();
      toast.error(
        `${invalidEvouchers.map((x) => x.code).join(", ")} cannot be unblocked`
      );
      return;
    }

    this.toggleConfirmUnblockDialog(true);
  };

  handleMultipleBlocking = async (action, successMessage) => {
    try {
      showLoading(true);
      toast.dismiss();
      await action();
      this.loadData(0);
      this.setState({ selectedEVouchers: [] });
      toast.success(successMessage);
    } finally {
      showLoading(false);
    }
  };

  blockMultiple = async (reason, isBlockAll = false) => {
    const { selectedEVouchers } = this.state;
    const payload = isBlockAll
      ? this.getSearchCriteria()
      : { ids: selectedEVouchers.map((x) => x.id) };

    await this.handleMultipleBlocking(
      () =>
        this.eVoucherService
          .block({
            ...payload,
            reason,
          })
          .then((res) => res?.data),
      "eVouchers have been blocked"
    );
    this.toggleConfirmBlockDialog(false);
    this.toggleConfirmBlockAllDialog(false);
  };

  unblockMultiple = async (isUnblockAll = false) => {
    const { selectedEVouchers } = this.state;
    const payload = isUnblockAll
      ? this.getSearchCriteria()
      : { ids: selectedEVouchers.map((x) => x.id) };

    await this.handleMultipleBlocking(
      () => this.eVoucherService.unblock(payload).then((res) => res?.data),
      "eVouchers have been unblocked"
    );
    this.toggleConfirmUnblockDialog(false);
    this.toggleConfirmUnblockAllDialog(false);
  };

  extendMultiple = async ({ reason, newValidityEnd }, isExtendAll = false) => {
    const { selectedEVouchers } = this.state;
    showLoading(true);
    const payload = isExtendAll
      ? this.getSearchCriteria()
      : { ids: selectedEVouchers.map((x) => x.id) };
    const response = await this.eVoucherExtensionRequestRestService.post({
      ...payload,
      eVoucherIds: payload.ids,
      newValidityEnd,
      reason,
    });
    showLoading(false);
    if (response && response.status === 201) {
      toast.success(GenericMessages.CreationExtensionEvoucherSuccessfulMessage);
      this.toggleExtendValidityDialog(false);
      this.toggleExtendValidityAllDialog(false);
      this.setState({ selectedEVouchers: [] });
      this.loadData(0);
    }
  };

  downloadSelectedEVouchers = async (password) => {
    const { selectedEVouchers } = this.state;
    const payload = { ids: selectedEVouchers.map((x) => x.id) };
    await this.downloadReportFileWithPassword(payload, password);
    this.toggleExportFileDialog(false);
  };

  getSearchCriteria = () => {
    const eVoucherBatchReference = this.state.eVoucherBatchReference;
    const eVoucherOrderReference = this.state.eVoucherOrderReference;
    const { code, evoucherStatus, evoucherProgramId } = this.state;
    return {
      eVoucherBatchReference,
      eVoucherOrderReference,
      code,
      evoucherProgramId: evoucherProgramId ? [evoucherProgramId] : [],
      status: evoucherStatus || [],
      ids: [],
    };
  };

  downloadAllEVouchers = async (password) => {
    const payload = this.getSearchCriteria();
    await this.downloadReportFileWithPassword(payload, password);
    this.toggleDownloadAllDialog(false);
  };

  downloadReportFileWithPassword = async (payload, password) => {
    toast.dismiss();
    showLoading(true);
    const response = await this.eVoucherService.download(payload);
    if (response.status === 200) {
      await EVoucherExporter.toProtectedZipReporting(
        response.data.data,
        password
      );
    }
    showLoading(false);
  };

  hasAnyCriterionValue = () => {
    const {
      eVoucherBatchReference,
      eVoucherOrderReference,
      code,
      evoucherProgramId,
      evoucherStatus,
    } = this.state;
    return (
      !!eVoucherBatchReference ||
      !!eVoucherOrderReference ||
      !!code ||
      !!evoucherProgramId ||
      evoucherStatus.length > 0
    );
  };
  validateSelectedItems = () => {
    const { selectedEVouchers } = this.state;
    if (selectedEVouchers.length === 0) {
      toast.dismiss();
      toast.error("Please select at least one eVoucher code");
      return false;
    }
    return true;
  };

  generateTableFilter() {
    const {
      searchBy,
      code,
      eVoucherBatchReference,
      eVoucherOrderReference,
      evoucherProgramId,
      evoucherPrograms,
      evoucherStatuses,
      evoucherStatus,
      selectedEVouchers,
      isShowBlockDialog,
      isShowUnblockDialog,
      isShowBlockAllDialog,
      isShowUnblockAllDialog,
      isShowExtendValidityDialog,
      isShowExtendValidityAllDialog,
      isShowHistoryDialog,
      isShowExportFileDialog,
      isShowDownloadAllDialog,
      total,
    } = this.state;
    return (
      <>
        <div className="row">
          <div className="col-md-12 col-lg-8">
            <div className="row form-group mb-3 pb-3">
              <label className="form-control-label d-inline-flex text-nowrap col-md-2">
                Search By:
              </label>
              <div className="col-md-10">
                <RowFormField
                  label={
                    <>
                      <input
                        type="radio"
                        name="SearchBy"
                        value={SearchEvoucherBy.Code}
                        className="mr-1"
                        onChange={this.onSearchByChange}
                        checked={searchBy === SearchEvoucherBy.Code}
                      />
                      Code
                    </>
                  }
                  htmlFor="code"
                >
                  <input
                    className="col-8 form-control SingleSN2"
                    id="code"
                    type="text"
                    placeholder="Enter Code"
                    value={code}
                    name="code"
                    onChange={this.onInputChange}
                    disabled={searchBy !== SearchEvoucherBy.Code}
                  />
                </RowFormField>
                <RowFormField
                  label={
                    <>
                      <input
                        type="radio"
                        name="SearchBy"
                        value={SearchEvoucherBy.EVoucherBatchReference}
                        className="mr-1"
                        onChange={this.onSearchByChange}
                        checked={
                          searchBy === SearchEvoucherBy.EVoucherBatchReference
                        }
                      />
                      eVoucher Batch Reference
                    </>
                  }
                  htmlFor="eVoucherBatchReference"
                >
                  <input
                    className="col-8 form-control SingleSN2"
                    id="eVoucherBatchReference"
                    type="text"
                    placeholder="Enter eVoucher Batch Reference"
                    value={eVoucherBatchReference}
                    name="eVoucherBatchReference"
                    onChange={this.onInputChange}
                    disabled={
                      searchBy !== SearchEvoucherBy.EVoucherBatchReference
                    }
                  />
                </RowFormField>
                <RowFormField
                  label={
                    <>
                      <input
                        type="radio"
                        name="SearchBy"
                        value={SearchEvoucherBy.EVoucherOrderReference}
                        className="mr-1"
                        onChange={this.onSearchByChange}
                        checked={
                          searchBy === SearchEvoucherBy.EVoucherOrderReference
                        }
                      />
                      eVoucher Order Reference
                    </>
                  }
                  htmlFor="EVoucherOrderReference"
                >
                  <input
                    className="col-8 form-control SingleSN2"
                    id="EVoucherOrderReference"
                    type="text"
                    placeholder="Enter eVoucher Order Reference"
                    value={eVoucherOrderReference}
                    name="eVoucherOrderReference"
                    onChange={this.onInputChange}
                    disabled={
                      searchBy !== SearchEvoucherBy.EVoucherOrderReference
                    }
                  />
                </RowFormField>
              </div>
            </div>
            <div className="row mb-3">
              <div className="col-md-6 col-lg-7 col-xl-6 row mx-0 mb-3">
                <label
                  className="align-self-center mb-0 form-control-label col-md-7 col-xl-5 px-0"
                  htmlFor="BatchProgramId"
                >
                  eVoucher Program:
                </label>
                <select
                  className="form-control col-md-5 xol-xl-7"
                  name="eVoucherProgramId"
                  id="eVoucherProgramId"
                  required
                  onChange={this.onProgramChange}
                  value={evoucherProgramId}
                >
                  <option value={0}>All Programs</option>
                  {evoucherPrograms &&
                    evoucherPrograms.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.shortName}
                      </option>
                    ))}
                </select>
              </div>

              <div className="col-md-4 col-lg-5 col-xl-4 row mx-0 mb-3">
                <label
                  className="align-self-center mb-0 form-control-label col-md-4 px-0"
                  htmlFor="BatchStatus"
                >
                  Status:{" "}
                </label>
                <select
                  className="form-control col-md-8"
                  name="evoucherStatus"
                  id="evoucherStatus"
                  required
                  onChange={this.onStatusChange}
                  value={evoucherStatus}
                >
                  <option value="">All Status</option>
                  {evoucherStatuses &&
                    evoucherStatuses.map((item) => (
                      <option key={item.id} value={item.id}>
                        {item.name}
                      </option>
                    ))}
                </select>
              </div>

              <div className="col-md-2 col-lg-12 col-xl-2 input-group row mb-3 pr-0">
                <div className="input-group-btn ml-auto">
                  <button className="btn btn-primary" onClick={this.search}>
                    <i className="fa fa-search" /> Search
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div
            className="col-md-12 col-lg-4 mb-2"
            style={{
              borderLeft: "solid 2px",
            }}
          >
            {selectedEVouchers.length > 0 && (
              <h4 className="text-center mb-2">
                {selectedEVouchers.length}&nbsp; eVouchers Selected:
              </h4>
            )}
            <div style={{ overflowY: "auto", maxHeight: 300 }}>
              {selectedEVouchers.map((x) => x.code).join(", ")}
            </div>
          </div>
        </div>

        <div
          className="d-flex align-items-center mb-2 p-3"
          style={{ background: "#d9d9d9", fontWeight: 600 }}
        >
          {selectedEVouchers.length > 0 && (
            <div className="mr-2">
              <i
                style={{ marginBottom: 4 }}
                className="fa fa-times-circle btn"
                aria-hidden="true"
                onClick={() => this.setState({ selectedEVouchers: [] })}
              ></i>
              {selectedEVouchers.length}&nbsp; Selected
            </div>
          )}

          {/* Block Button */}
          {AuthenticationManager.isAuthorized(
            ResourceID.EVoucherListingPageMultipleBlockButton
          ) && (
            <EVoucherActionDropdown
              buttonClassName="btn-danger"
              actionTitle="Block"
              total={total}
              selectedEVouchersLength={selectedEVouchers.length}
              hasAnyCriterionValue={this.hasAnyCriterionValue}
              onClickAll={() => this.toggleConfirmBlockAllDialog(true)}
              onClickSelectedEVouchers={() => {
                if (this.validateSelectedItems()) {
                  this.openBlockDialog();
                }
              }}
            />
          )}

          {/* Unblock Button */}
          {AuthenticationManager.isAuthorized(
            ResourceID.EVoucherListingPageMultipleBlockButton
          ) && (
            <EVoucherActionDropdown
              buttonClassName="btn-secondary"
              actionTitle="Unblock"
              total={total}
              selectedEVouchersLength={selectedEVouchers.length}
              hasAnyCriterionValue={this.hasAnyCriterionValue}
              onClickAll={() => this.toggleConfirmUnblockAllDialog(true)}
              onClickSelectedEVouchers={() => {
                if (this.validateSelectedItems()) {
                  this.openUnblockDialog();
                }
              }}
            />
          )}

          {/* Extend Button */}
          {AuthenticationManager.isAuthorized(
            ResourceID.EVoucherListingPageMultipleExtendButton
          ) && (
            <EVoucherActionDropdown
              buttonClassName="btn-warning"
              actionTitle="Extend"
              total={total}
              selectedEVouchersLength={selectedEVouchers.length}
              hasAnyCriterionValue={this.hasAnyCriterionValue}
              onClickAll={() => this.toggleExtendValidityAllDialog(true)}
              onClickSelectedEVouchers={() => {
                if (this.validateSelectedItems()) {
                  this.toggleExtendValidityDialog(true);
                }
              }}
            />
          )}

          {/* Download Button */}
          {AuthenticationManager.isAuthorized(
            ResourceID.EVoucherListingPageDownloadButton
          ) && (
            <EVoucherActionDropdown
              buttonClassName="btn-success"
              actionTitle="Download"
              total={total}
              selectedEVouchersLength={selectedEVouchers.length}
              hasAnyCriterionValue={this.hasAnyCriterionValue}
              onClickAll={() => this.toggleDownloadAllDialog(true)}
              onClickSelectedEVouchers={() => {
                if (this.validateSelectedItems()) {
                  this.toggleExportFileDialog(true);
                }
              }}
            />
          )}

          {/* History Button */}
          <button
            className="btn btn-outline-secondary ml-1"
            data-target="#HistoryPopup"
            data-toggle="modal"
            onClick={() => this.toggleHistoryDialog(true)}
          >
            History
          </button>
        </div>

        {isShowExtendValidityDialog && (
          <ExtendValidityDialog
            onCancel={() => this.toggleExtendValidityDialog(false)}
            onProceed={(reason) => this.extendMultiple(reason, false)}
            reasonType={"Reason"}
            placeholderText={"Enter reason for eVoucher extension"}
          />
        )}

        {isShowExtendValidityAllDialog && (
          <ExtendValidityDialog
            onCancel={() => this.toggleExtendValidityAllDialog(false)}
            onProceed={(reason) => this.extendMultiple(reason, true)}
            reasonType={"Reason"}
            placeholderText={"Enter reason for eVoucher extension"}
          />
        )}

        {isShowBlockDialog && (
          <BaseConfirmReasonDialog
            onCancel={() => this.toggleConfirmBlockDialog(false)}
            onProceed={(res) => this.blockMultiple(res, false)}
            message={`Are you sure you want to block ${selectedEVouchers.length} eVouchers?`}
            reasonType="Reason For Blocking"
            placeholderText="Enter reason for blocking"
          />
        )}

        {isShowBlockAllDialog && (
          <BaseConfirmReasonDialog
            onCancel={() => this.toggleConfirmBlockAllDialog(false)}
            onProceed={(res) => this.blockMultiple(res, true)}
            message={`Are you sure you want to block ${total} eVouchers?`}
            reasonType="Reason For Blocking"
            placeholderText="Enter reason for blocking"
          />
        )}

        {isShowUnblockDialog && (
          <BaseConfirmReasonDialog
            onCancel={() => this.toggleConfirmUnblockDialog(false)}
            onProceed={() => this.unblockMultiple(false)}
            message={`Are you sure you want to unblock ${selectedEVouchers.length} eVouchers?`}
          />
        )}

        {isShowUnblockAllDialog && (
          <BaseConfirmReasonDialog
            onCancel={() => this.toggleConfirmUnblockAllDialog(false)}
            onProceed={() => this.unblockMultiple(true)}
            message={`Are you sure you want to unblock ${total} eVouchers?`}
          />
        )}

        {isShowHistoryDialog && (
          <EVoucherActionsHistoryModal
            onClose={() => this.toggleHistoryDialog(false)}
          />
        )}
        {isShowExportFileDialog && (
          <FileDownloadModal
            onSubmit={(password) => this.downloadSelectedEVouchers(password)}
            onCancel={() => this.toggleExportFileDialog(false)}
            title={"Enter password for export file"}
          />
        )}
        {isShowDownloadAllDialog && (
          <FileDownloadModal
            onSubmit={(password) => this.downloadAllEVouchers(password)}
            onCancel={() => this.toggleDownloadAllDialog(false)}
            title={"Enter password for export file"}
          />
        )}
      </>
    );
  }

  generateTableContent() {
    const { data, selectedEVouchers, isSelectAll } = this.state;
    return (
      <>
        <thead>
          <tr>
            <th>
              <input
                className="btn"
                type="checkbox"
                checked={isSelectAll}
                onChange={(e) => this.onSelectAll(e)}
              />
            </th>
            <th>Code</th>
            <th style={{ textTransform: "none" }}>eVoucher Program</th>
            <th>
              Expiry Date
              <i
                id="ValidityEnd"
                className="fas fa-sort-alpha-down"
                onClick={this.toggleSort}
              />
            </th>
            <th>Status</th>
            <th>
              Updated On
              <i
                id="UpdatedOn"
                className="fas fa-sort-alpha-down"
                onClick={this.toggleSort}
              />
            </th>
          </tr>
        </thead>
        <tbody>
          {data &&
            data.map((item) => (
              <tr
                key={item.id}
                className="pending"
                onClick={() => this.onRowClick(item.id)}
              >
                <td onClick={(e) => e.stopPropagation()}>
                  <input
                    className="btn"
                    type="checkbox"
                    checked={selectedEVouchers.some(
                      (selectedItem) => selectedItem.id === item.id
                    )}
                    onChange={(e) => this.onSelectEVoucher(e, item)}
                  />
                </td>
                <td>{item.code}</td>
                <td>{item.eVoucherProgram?.shortName}</td>
                <td>{DateHelper.toDisplayDateFormat(item.validityEnd)}</td>
                <td className={EVoucherStatus.getColor(item.status)}>
                  {item.status}
                </td>
                <td>
                  {item.updatedOn &&
                    DateHelper.toDisplayDateTimeFormat(item.updatedOn)}
                </td>
              </tr>
            ))}
        </tbody>
      </>
    );
  }
}
